import { ColorId } from '../minigame/match2-timestep/game/defs/block';

/**
 * Retrieve primary and secondary color for the super lollipop effect
 * If the primary color is not in the available colors, user the most common color as primary color
 * The secondary color is the most common color that is not the primary color
 * This way, the super lollipop will always have targets, even if the its primary color is not present in the grid
 * @param primaryColor
 * @param availableColors
 * @returns
 */
export function getSuperLollipopTargetColors(
  primaryColor: ColorId,
  availableColors: ColorId[],
): { primary: ColorId; secondary: ColorId } {
  // First, count the colors
  const colorCounts: Partial<Record<ColorId, number>> = {};
  for (const color of availableColors) {
    colorCounts[color] = (colorCounts[color] || 0) + 1;
  }

  // Find the primary color
  let primary: ColorId = primaryColor;
  if (!colorCounts[primaryColor]) {
    let primaryCount = 0;
    for (const [color, count] of Object.entries(colorCounts)) {
      if (count > primaryCount) {
        primary = color as ColorId;
        primaryCount = count;
      }
    }
  }

  // Find the secondary color
  let secondary: ColorId = primary;
  let secondaryCount = 0;
  for (const [color, count] of Object.entries(colorCounts)) {
    if (color === primary) {
      continue;
    }
    if (count > secondaryCount) {
      secondary = color as ColorId;
      secondaryCount = count;
    }
  }

  return {
    primary,
    secondary,
  };
}
